import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { StaticPageEmbedded } from 'pages/static';

const StyledWrapper = styled.div`
  height: 100%;
  background: ${Styles.color.white};

  // Override styles defined in Sanity
  // Neglect nav-header spacing when used inside tabs
  [role='tabpanel'] &.static-page {
    #hero {
      margin-block-start: 0;
    }
    #action-bar {
      position: sticky;
      inset-block-end: 0;
    }
  }
`;

// Render Popeyes Rewards static page.
// Special use case for users that are not signed up on Loyalty.
// Please refer to LYL-2702.
const LoyaltyNotEnrolled: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledWrapper className="static-page">
      <StaticPageEmbedded pathname={formatMessage({ id: 'routes.popeyesRewards' })} />
    </StyledWrapper>
  );
};

export default LoyaltyNotEnrolled;
